/* DO NOT EDIT - This is an automated file */
  /* eslint-disable */
  import { HTMLAttributes, DetailedHTMLProps } from "react";
  import { applyPolyfills, defineCustomElements, JSX as LocalJSX } from '@cvsr/wc-cvs-frontend-components/loader';

type ReactProps<T> = {
    [P in keyof T]?: DetailedHTMLProps<HTMLAttributes<T[P]>, T[P]>;
};

type StencilProps<T> = {
    [P in keyof T]?: Omit<T[P], "ref"> | HTMLAttributes<T>;
};

type StencilToReact<T = LocalJSX.IntrinsicElements, U = HTMLElementTagNameMap> = StencilProps<T> & ReactProps<U>;
declare global {
    export namespace JSX {
        interface IntrinsicElements extends StencilToReact {}
    }
}

  applyPolyfills().then(() => {
      if (typeof window !== 'undefined') {
          defineCustomElements(window);
      }
  });